<template>
  <div class="bar">
    <div :id="id" style="height: 100%; width: 100%"></div>
  </div>
</template>

<script  type="text/ecmascript-6">
// import * as echarts from 'echarts';

export default {
  props: [ 'options', 'axis'],
  data() {
    return {
      id:"bar"
    }
  },
  mounted() {
    setTimeout(() => {
      this.draw()
    }, 500)
  },
  watch: {
    options: {
      handler: function(val, old) {
        this.draw()
      },
      deep: true,
    },
  },
  methods: {
    draw() {
      let myChart = this.$echarts.init(document.getElementById(this.id))
      myChart.setOption({
        grid: {
          left: '0%',
          right: '0%',
          bottom: '4%',
          top: '4%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          // axisPointer: {
          //   type: "cross",
          //   crossStyle: {
          //     color: "#999",
          //   },
          // },
        },
        // legend: {
        //   data: [ '访问量'],
        //   top: 10,
        // },
        // data: this.options.xData,
        // data: ['2023-05-01', '2023-05-02', '2023-05-03', '2023-05-04'],
        xAxis: [
          {
            type: 'category',
            data: this.options.xData,
            axisLine: {
              lineStyle: {
                color: '#F2F2F2',
              },
            },
            axisLabel: {
              color: '#999999',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            min: 0,
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: '#F2F2F2',
              },
            },
            splitLine: {
              lineStyle: {
                color: '#F2F2F2',
              },
            },
            axisLabel: {
              formatter: '{value}',
              color: '#999999',
            },
          },
          {
            type: 'value',
            name: '',
            min: 0,
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: '#F2F2F2',
              },
            },
            splitLine: {
              lineStyle: {
                color: '#F2F2F2',
              },
            },
            axisLabel: {
              formatter: '{value}',
              color: '#999999',
            },
          },
        ],
        series: [
          {
            name: '访问量',
            type: 'bar',
            yAxisIndex: 1,
            barWidth: '12',
            itemStyle: {
              borderWidth: 3,
              borderColor: '#428DFF',
              color: '#428DFF',
              normal: {
                color:"#4992ff",
                //   [
                //   {
                //     offset: 0,
                //     color: '#428DFF', // 0% 处的颜色
                //   },
                //   {
                //     offset: 0.98,
                //     color: '#7AB5FF', // 100% 处的颜色
                //   },
                // ],
                shadowColor: 'rgba(5, 213, 255, 1)',
                shadowBlur: 4,
                barBorderRadius: 12,
              },
            },
            // data: [18,  15, 14],
            data: this.options.yData,
          },
        ],
      })
    },
  },
}
</script>

<style scoped lang="scss">
.bar {
  height: 100%;
  width: 100%;
}
</style>
